import React, { useEffect } from "react";
import { config } from "@triare/auth-redux";
import Layout from "../../components/Layout";
import ReviewsContent from "../../components/Pages/Reviews";
import { useTranslation } from "react-i18next";

const { displayName } = config;

export default function Reviews() {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = `${displayName}: Reviews`;
  }, []);

  return (
    <Layout title={t("routes.reviews")}>
      <ReviewsContent />
    </Layout>
  );
}
